import React, { useEffect } from 'react';
import { Segment, Sidebar } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { clearToast } from '../app/app-slice';

export default function Toast({ duration = 4000 }) {
  const dispatch = useDispatch();
  const toastMessage = useSelector((state) => {
    return state.app?.toastMessage;
  });

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearToast());
    }, duration);
  }, [toastMessage]);

  if (!toastMessage) {
    return;
  }

  return (
    <Sidebar className="toast" as={Segment} direction={'top'} animation={'overlay'} visible={!!toastMessage}>
      {toastMessage}
    </Sidebar>
  );
}
